import React from 'react';
import { ChannelCallback } from './ChannelCallback';

/** /auth/tiktok/callback — the shared sign-in callback (ChannelCallback) for TikTok. */
const TikTokCallback: React.FC = () => <ChannelCallback platform="tiktok" />;

export default TikTokCallback;
